import useSwrNoCache from '@/script/useSwrNoCache.mjs'
import useHTTP from '@/hooks/useHTTP.mjs'

export default (key, rowKey, defaultArgs = {}) => {
    return (userArgs) => {
        const http = useHTTP()
        const args = {...defaultArgs, ...userArgs}
        const {data, mutate} = useSwrNoCache(() => http.get(key, args))

        if (data) {
            const pairs = data.map((e) => [e[rowKey], e])
            const dict = Object.fromEntries(pairs)
            return {dict, list: data, pairs, mutate}
        }
        else {
            return {dict: {}, list: [], pairs: [], mutate}
        }
    }
}
